module.exports = __webpack_public_path__ + "img/fskXL.5348c0d3.png";